import {createReducer} from '@reduxjs/toolkit';

import {setDefaultStateForCompleteOrder} from '../../../actions/completeOrder/completeOrder';
import {getOrderReviewTotals} from '../../orderReviewTotals/orderReviewTotals';
import {startSetCheckoutStepSaga} from '../../sagaStep/sagaStep';
import {saveCustomerAddresses} from '../customerAddresses/customerAddresses';

export const initialState = false;

/**
 * isLoading reducer
 *
 * @return {boolean} - isLoading state
 */
export const isLoading = createReducer(initialState, builder =>
    builder
        .addCase(saveCustomerAddresses.rejected, () => false)
        .addCase(getOrderReviewTotals.rejected, () => false)
        .addCase(startSetCheckoutStepSaga, () => false)
        .addCase(setDefaultStateForCompleteOrder, () => true),
);
